import { useState, useEffect, useMemo } from "react";

interface Otions {
  leftTime?: number;
  targetDate?: number | Date | undefined;
  interval?: number;
  onEnd?: () => void;
}

const calcLeft = (target: Date | number | undefined) => {
  if (!target) return 0;
  const left = new Date(target).getTime() - Date.now();
  return left < 0 ? 0 : left;
};

const useCountDown = (options: Otions = {}) => {
  const { targetDate, interval = 1000 } = options || {};
  const target = useMemo(() => {
    return targetDate;
  }, [targetDate]);

  const [timeLeft, setTimeLeft] = useState(() => calcLeft(target));

  useEffect(() => {
    if (!target) {
      setTimeLeft(0);
      return;
    }
    // 立即执行一次
    setTimeLeft(calcLeft(target));
    const timer = setInterval(() => {
      const targetLeft = calcLeft(target);
      setTimeLeft(targetLeft);
      if (targetLeft === 0) {
        clearInterval(timer);
      }
    }, interval);
    return () => {
      // 清理定时器
      clearInterval(timer);
    };
  }, [interval, target]);

  return [timeLeft] as const;
};

export default useCountDown;
